"use client"
import classNames from "classnames"
import styles from "../../styles/LandingPage/Patients.module.scss"
import Image from "next/image"
import StyledText from "../typography/typography-component"
import skColors from "../../styles/skColors"
import Button from "../components/Button/Button"
import { useTranslations } from "next-intl"

const DoctorSection = (props: { onClick: () => void }) => {
  const t = useTranslations("index.doctor")
  return (
    <div style={{ height: "100%" }} className={classNames(styles.doctorContainer)}>
      <Image
        src={"/svg/doctor.svg"}
        width={400}
        height={400}
        alt={"doctor"}
        className={styles.doctorsImage}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <div className={styles.doctorContent}>
        <StyledText color={skColors.turquoise[600]} variant={"h2"}>
          {t("title")}
        </StyledText>

        <StyledText variant={"pLarge"}>{t("subtitle")}</StyledText>
        <Button hug onClick={props.onClick} variant={"primary"}>
          {t("cta")}
        </Button>
      </div>
    </div>
  )
}
export default DoctorSection
